// extracted by mini-css-extract-plugin
module.exports = {"controls":"MeasurementsSaveControls_controls__2GwGu","button":"MeasurementsSaveControls_button__2yYmD"};